const PRINT_DOCUMENT_STYLES = `
  @page {
    size: auto;
    margin: 16mm;
  }

  html, body {
    margin: 0;
    padding: 0;
    background: #fff !important;
    color: #000 !important;
  }

  body {
    min-height: auto;
  }

  .md-text-component {
    display: block !important;
    height: auto !important;
    width: auto !important;
    max-width: none !important;
    padding: 0 !important;
    overflow: visible !important;
  }

  .md-text-component__actions,
  [data-radix-scroll-area-scrollbar] {
    display: none !important;
  }

  .md-text-component__scroll-area,
  .md-text-component__viewport {
    height: auto !important;
    overflow: visible !important;
  }

  .md-text-component__content {
    max-width: none !important;
    columns: 1 !important;
    color: #000 !important;
  }

  .md-text-component__content,
  .md-text-component__content * {
    color: #000 !important;
  }

  .md-text-component__content h1,
  .md-text-component__content h2,
  .md-text-component__content h3,
  .md-text-component__content h4,
  .md-text-component__content h5,
  .md-text-component__content h6 {
    break-after: avoid-page;
    page-break-after: avoid;
  }

  .md-text-component__content h1 + *,
  .md-text-component__content h2 + *,
  .md-text-component__content h3 + *,
  .md-text-component__content h4 + *,
  .md-text-component__content h5 + *,
  .md-text-component__content h6 + * {
    break-before: avoid-page;
    page-break-before: avoid;
  }

  .md-text-component__content pre,
  .md-text-component__content table,
  .md-text-component__content img,
  .md-text-component__content svg {
    break-inside: avoid;
  }
`

function getPrintDocument(printableMarkup: string, stylesheetMarkup: string): string {
  return `<!DOCTYPE html>
<html class="${document.documentElement.className}">
  <head>
    <meta charset="utf-8" />
    <title></title>
    ${stylesheetMarkup}
    <style>${PRINT_DOCUMENT_STYLES}</style>
  </head>
  <body>
    ${printableMarkup}
  </body>
</html>`
}

function createPrintFrame(): HTMLIFrameElement {
  const printFrame = document.createElement('iframe')
  printFrame.setAttribute('aria-hidden', 'true')
  printFrame.style.position = 'fixed'
  printFrame.style.right = '0'
  printFrame.style.bottom = '0'
  printFrame.style.width = '0'
  printFrame.style.height = '0'
  printFrame.style.border = '0'
  printFrame.style.visibility = 'hidden'

  document.body.appendChild(printFrame)

  return printFrame
}

export function printMdTextContent(printableElement: HTMLDivElement | null) {
  const printableMarkup = printableElement?.outerHTML

  if (!printableMarkup) {
    return
  }

  const stylesheetMarkup = Array.from(document.querySelectorAll('link[rel="stylesheet"], style'))
    .map((node) => node.outerHTML)
    .join('\n')

  const printFrame = createPrintFrame()
  const cleanup = () => {
    window.setTimeout(() => {
      printFrame.remove()
    }, 0)
  }

  printFrame.addEventListener(
    'load',
    () => {
      const frameWindow = printFrame.contentWindow

      if (!frameWindow) {
        cleanup()
        return
      }

      frameWindow.addEventListener('afterprint', cleanup, { once: true })

      window.setTimeout(() => {
        frameWindow.focus()
        frameWindow.print()
      }, 300)
    },
    { once: true }
  )

  printFrame.srcdoc = getPrintDocument(printableMarkup, stylesheetMarkup)
}
